module.exports = __webpack_public_path__ + "static/media/schnyder-s-normal-600.1e1de967.ttf";